import { FlexBox, Text } from '@trmediaab/zebra';
import { WeatherIcon, WindDirection } from '@trmediaab/zebra-icons';
import { formatNumber } from '@trmediaab/zebra-utils';
import { Fragment } from 'react';

const Weather = ({ meets, color = 'white', ...wrapperProps }) => {
  const weathers = meets.map(meet => meet.weather);

  if (weathers.every(weather => !weather)) {
    return null;
  }

  return (
    <FlexBox gap="3" {...wrapperProps}>
      {meets.map(({ weather: weatherByMeet, id }, idx) => {
        if (weatherByMeet == null) {
          return (
            <Text key={id} color={color}>
              -
            </Text>
          );
        }

        const temp = formatNumber(weatherByMeet.temperature, {
          maximumFractionDigits: 0,
        });

        return (
          <Fragment key={id}>
            <FlexBox gap="2" alignItems="center" color={color}>
              <WeatherIcon
                size={{
                  xs: '19px',
                  lg: '26px',
                }}
                code={weatherByMeet.weather}
              />
              <Text fontWeight="bold" fontSize={{ xs: '1', lg: '2' }}>
                {temp}°
              </Text>

              {weathers.length === 1 && (
                <FlexBox gap="2" alignItems="center" color={color}>
                  <WindDirection
                    direction={weatherByMeet.wind_direction}
                    size={{
                      xs: '14px',
                      lg: '19px',
                    }}
                  />
                  <Text fontWeight="bold" fontSize={{ xs: '1', lg: '2' }}>
                    {formatNumber(weatherByMeet.wind_strength, {
                      maximumFractionDigits: 0,
                    })}{' '}
                    m/s
                  </Text>
                </FlexBox>
              )}
            </FlexBox>

            {idx < weathers.length - 1 && (
              <Text
                display="flex"
                alignItems="center"
                color={color}
                fontWeight="bold"
                fontSize={{ xs: '1', lg: '2' }}
              >
                /
              </Text>
            )}
          </Fragment>
        );
      })}
    </FlexBox>
  );
};

export default Weather;
